import logo from './logo.svg';
import './App.css';
import AppRoutes from './Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function App() {
  return (
    <>
    <ToastContainer />
    <AppRoutes/>
    </>
  );
}

export default App;
